import { render, staticRenderFns } from "./reporteCorte.vue?vue&type=template&id=504800bb&scoped=true"
import script from "./reporteCorte.vue?vue&type=script&lang=js"
export * from "./reporteCorte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504800bb",
  null
  
)

export default component.exports